import {
	SelectionsActionTypes,
	SelectionStep,
	SET_QR_CODE,
	SET_SELECTED_LAYOUT,
	SET_SELECTED_OPTIONS,
	SET_SELECTED_STYLE,
	SET_SELECTION_STEP,
	THUNK,
} from "./selectionsTypes";

// TypeScript infers that this function is returning SendMessageAction
export function setSelectionStep(step: SelectionStep): SelectionsActionTypes {
	return {
		type: SET_SELECTION_STEP,
		step,
	};
}

export function setSelectedOptionsValue(optionsValue: number): SelectionsActionTypes {
	return {
		type: SET_SELECTED_OPTIONS,
		optionsValue,
	};
}

export function setSelectedLayout(layoutIndex: number): SelectionsActionTypes {
	return {
		type: SET_SELECTED_LAYOUT,
		layoutIndex,
	};
}

export function setSelectedStyle(styleIndex: number): SelectionsActionTypes {
	return {
		type: SET_SELECTED_STYLE,
		styleIndex,
	};
}

export function setQrCode(qrCode?: string): SelectionsActionTypes {
	return {
		type: SET_QR_CODE,
		qrCode,
	};
}

export const isiOS = ["iPad", "iPhone"].includes(navigator.platform);
export const isDesktop = ["Mac", "Win32"].some((platform) => navigator.platform.includes(platform));
export const isAndroid = !isDesktop && navigator.userAgent.includes("Android");

console.log({ isiOS, isAndroid, isDesktop });

export const androidIntent =
	"intent://arvr.google.com/scene-viewer/1.2?file=http%3A%2F%2Fwww.gstatic.com%2Far%2Fcore%2Fviewer%2Fcarousel%2Fcloud9%2Fstaging%2Fc9_error.glb&referrer=google.com%3AIE%3Apoc&cloudArAssetId={cloudArAssetId}&streaming_api_key=AIzaSyAs9-3yvPbDpxQhcZMoF6iFRBiDN3h6c5c&streaming_service_address=fb602a60-89db-4763-b4d8-509e1291ae21.streamplease.net%3A443&streaming_test_dryrun=true&card_content=https%3A%2F%2Fwww.gstatic.com%2Far%2Fcore%2Fviewer%2Fcarousel%2Fcloud9%2Fim_edge.html&enable_server_touch_handle=true#Intent;scheme=https;action=android.intent.action.VIEW;package=com.google.android.googlequicksearchbox;S.browser_fallback_url=https%3A%2F%2Farvr.google.com%2Fstreaming%2Fhomeview%3Fscene_uri%3Dhttps%253A%252F%252Farvr.google.com%252Fscene-viewer%252F1.2%253Ffile%253Dtest-file%2526cloudArAssetId%253D{cloudArAssetId}%26streaming_session_address%3Dfb602a60-89db-4763-b4d8-509e1291ae21.streamplease.net%253A443%26streaming_session_key%3DAIzaSyAs9-3yvPbDpxQhcZMoF6iFRBiDN3h6c5c%26camera_controls%3Dfalse%26hide_install%3Dtrue;end";

// Sends users without the google app installed to the app store
export const iosIntent =
	"https://search.app.goo.gl/?ius=googleapp&ibi=com.google.GoogleMobile&efr=1&imv=123&link=https%3A%2F%2Fgoo.gl%2Fiosgoogleapp%2Fdefault%3Furl%3Dgoogleapp%253A%252F%252Fopen-url%253Furl%253Dhttps%25253A%25252F%25252Farvr.google.com%25252Fscene-viewer%25253Ffile%25253Dhttp%2525253A%2525252F%2525252Fwww.gstatic.com%2525252Far%2525252Fcore%2525252Fviewer%2525252Fcarousel%2525252Fcloud9%2525252Fstaging%2525252Fc9_error.glb%252526referrer%25253Dgoogle.com%2525253AIE%2525253Apoc%252526cloudArAssetId%25253D{cloudArAssetId}%252526streaming_api_key%25253DAIzaSyAs9-3yvPbDpxQhcZMoF6iFRBiDN3h6c5c%252526streaming_service_address%25253Dfb602a60-89db-4763-b4d8-509e1291ae21.streamplease.net%2525253A443%252526streaming_test_dryrun%25253Dtrue%252526card_content%25253Dhttps%2525253A%2525252F%2525252Fwww.gstatic.com%2525252Far%2525252Fcore%2525252Fviewer%2525252Fcarousel%2525252Fcloud9%2525252Fim_edge.html%252526enable_server_touch_handle%25253Dtrue&ifl=https%3A%2F%2Farvr.google.com%2Fstreaming%2Fhomeview%3Fscene_uri%3Dhttps%253A%252F%252Farvr.google.com%252Fscene-viewer%252F1.2%253Ffile%253Dtest-file%2526cloudArAssetId%253D{cloudArAssetId}%26streaming_session_address%3Dfb602a60-89db-4763-b4d8-509e1291ae21.streamplease.net%253A443%26streaming_session_key%3DAIzaSyAs9-3yvPbDpxQhcZMoF6iFRBiDN3h6c5c%26camera_controls%3Dfalse%26hide_install%3Dtrue";

// Private preview
const html5Intent =
	"https://arvr.google.com/streaming/homeview?scene_uri=https%3A%2F%2Farvr.google.com%2Fscene-viewer%2F1.2%3Ffile%3Dtest-file%26cloudArAssetId%3D{cloudArAssetId}&streaming_session_address=fb602a60-89db-4763-b4d8-509e1291ae21.streamplease.net%3A443&streaming_session_key=AIzaSyAs9-3yvPbDpxQhcZMoF6iFRBiDN3h6c5c&camera_controls=false&hide_install=true&timeout_seconds={timeoutSeconds}";

const getIntent = () => {
	// if (isAndroid) return androidIntent;
	// if (isiOS) return iosIntent;
	return html5Intent;
};

const timeoutSeconds = 300;

// clouldArAssetId is our one param we can hand into unreal
export function launchExperience(code?: string): SelectionsActionTypes {
	// if (isDesktop) {
	// 	const url = process.env.PUBLIC_URL + (code ? "/#/" + code : "/");
	// 	return setQrCode(url);
	// }
	let href = getIntent();
	href = href.split("{cloudArAssetId}").join(code ?? "");
	href = href.split("{timeoutSeconds}").join("" + timeoutSeconds);
	window.open(href, "_blank");
	// Hack so I dont have to install thunk
	return {
		type: THUNK,
	};
}
export function launchHtmlExperience(code = ""): void {
	const href = html5Intent.split("{cloudArAssetId}").join(code ?? "");
	window.open(href, "_blank");
}
